<template>
  <div class="client-layout" :class="themeClass">
    <ClientSidebar />
    <div class="main-content">
      <ClientTopbar />
      <main class="content-area">
        <router-view />
      </main>
    </div>

    <div v-if="mostrarAvisoGracia" class="aviso-gracia-overlay" @click.self="cerrarAvisoGracia">
      <div class="aviso-gracia-card">
        <div class="aviso-gracia-icono"><i class="bi bi-exclamation-triangle-fill"></i></div>
        <h3 class="aviso-gracia-titulo">Pago vencido del plan</h3>
        <p class="aviso-gracia-msg">
          Tu suscripcion esta en periodo de gracia. Regulariza el pago para evitar la suspension del servicio.
          <span v-if="fechaFinGracia"><br/>Vence: <strong>{{ fechaFinGracia }}</strong></span>
        </p>
        <div class="aviso-gracia-acciones">
          <button class="aviso-gracia-btn-secundario" @click="cerrarAvisoGracia">Mas tarde</button>
          <button class="aviso-gracia-btn-primario" @click="irAPago">
            <i class="bi bi-credit-card-2-front me-2"></i>Pagar ahora
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ClientSidebar from '@/components/ClientSidebar.vue'
import ClientTopbar from '@/components/ClientTopbar.vue'
import themeManager from '@/store/theme'

const AVISO_GRACIA_SESSION_KEY = 'aviso_gracia_visto'

export default {
  name: 'ClientLayout',
  components: {
    ClientSidebar,
    ClientTopbar,
  },
  data() {
    return {
      mostrarAvisoGracia: false
    }
  },
  computed: {
    themeClass() {
      return themeManager.themeClass;
    },
    fechaFinGracia() {
      return this.$store.state.subscription?.fecha_fin || ''
    }
  },
  watch: {
    '$store.getters.isSubscriptionInGrace'(esGracia) {
      if (esGracia) this.evaluarAvisoGracia()
    }
  },
  mounted() {
    themeManager.init();
    if (this.$store.getters.estaAutenticado) {
      this.$store.dispatch('cargarPermisosEfectivos').finally(() => {
        this.evaluarAvisoGracia()
      });
    }
    this.evaluarAvisoGracia()
  },
  methods: {
    evaluarAvisoGracia() {
      if (!this.$store.getters.isSubscriptionInGrace) return
      try {
        if (sessionStorage.getItem(AVISO_GRACIA_SESSION_KEY) === '1') return
      } catch (e) { /* sessionStorage indisponible */ }
      this.mostrarAvisoGracia = true
    },
    cerrarAvisoGracia() {
      this.mostrarAvisoGracia = false
      try {
        sessionStorage.setItem(AVISO_GRACIA_SESSION_KEY, '1')
      } catch (e) { /* ignorar */ }
    },
    irAPago() {
      this.cerrarAvisoGracia()
      this.$router.push('/gestion-pago')
    }
  }
}
</script>

<style scoped>
.client-layout {
  display: flex;
  background-color: var(--bg-light);
  color: var(--text-primary);
  min-height: 100vh;
}

/* Tema oscuro para el layout */
.dark-theme .client-layout {
  background-color: var(--bg-dark);
}

/* Sidebar ocupa un ancho fijo */
.client-layout > :first-child {
  width: 250px;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  overflow-y: auto;
  background-color: var(--bg-light);
  border-right: 1px solid var(--border-color);
}

/* Tema oscuro para sidebar */
.dark-theme .client-layout > :first-child {
  background-color: var(--bg-dark);
}

/* Contenido principal a la derecha del sidebar */
.main-content {
  margin-left: 250px;
  width: calc(100% - 250px);
  display: flex;
  flex-direction: column;
  height: 100vh;
  background-color: var(--bg-light);
}

/* Tema oscuro para main content */
.dark-theme .main-content {
  background-color: var(--bg-dark);
}

/* Topbar fijo en la parte superior del main content */
.main-content > .client-topbar {
  flex: 0 0 auto;
  width: 100%;
  position: sticky;
  top: 0;
  z-index: 1000;
}

/* Contenido debajo del topbar, scrollable */
.content-area {
  flex: 1 1 auto;
  overflow-y: auto;
  padding: 20px;
  background-color: var(--bg-light);
}

/* Tema oscuro para content area */
.dark-theme .content-area {
  background-color: var(--bg-dark);
}

.aviso-gracia-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.55);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2000;
}

.aviso-gracia-card {
  background: white;
  border-radius: 12px;
  padding: 28px 28px 22px;
  max-width: 460px;
  width: calc(100% - 32px);
  box-shadow: 0 24px 48px rgba(0, 0, 0, 0.25);
  text-align: center;
}

.aviso-gracia-icono {
  font-size: 2.6rem;
  color: #f59f00;
  margin-bottom: 8px;
}

.aviso-gracia-titulo {
  margin: 0 0 8px;
  font-size: 1.25rem;
  font-weight: 600;
  color: #212529;
}

.aviso-gracia-msg {
  color: #495057;
  font-size: 0.95rem;
  line-height: 1.5;
  margin: 0 0 18px;
}

.aviso-gracia-acciones {
  display: flex;
  justify-content: center;
  gap: 10px;
}

.aviso-gracia-btn-primario,
.aviso-gracia-btn-secundario {
  border: none;
  border-radius: 8px;
  padding: 10px 18px;
  font-weight: 500;
  cursor: pointer;
}

.aviso-gracia-btn-primario {
  background: #0d6efd;
  color: white;
}

.aviso-gracia-btn-primario:hover { background: #0b5ed7; }

.aviso-gracia-btn-secundario {
  background: #e9ecef;
  color: #495057;
}

.aviso-gracia-btn-secundario:hover { background: #dee2e6; }
</style>
